<template>
    <div class="equipment-file-container flex">
        <div class="file-input">
            <button
                v-if="!hasFile"
                :id="'file-button-' + qr"
                type="button"
                @click="chooseFile('file-id-' + qr)"
                class="review-link mr-2"
            >Dodaj aktivacijski kod</button>

            <button
                v-else
                :id="'file-button-' + qr"
                type="button"
                @click="chooseFile('file-id-' + qr)"
                class="review-link mr-2"
            >Promijeni aktivacijski kod</button>

            <input
                :id="'file-id-' + qr"
                :name="'file-id-' + qr"
                style="display: none;"
                type="file"
                @change="processFile($event)"
                accept="application/pdf,image/png"
            />
        </div>
        <div v-if="hasFile" class="existing-file flex">
            <a class="pt-1 mx-2 qr-file-name" v-text="fileName" target="_blank" :href="fileUrl"></a>

            <button
                type="button"
                @click="removeFile()"
                class="flex btn btn-delete border-0 py-0"
            ></button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

export default {
    props: {
        qr: {
            required: false,
            type: String,
        }
    },

    data () {
        return {
            hasFile: false,
            fileUrl: '',
            fileName: '',
        }
    },

    mounted () {
        this.checkFileExists()
    },

    methods: {
        checkFileExists() {
            if (!this.qr || typeof this.qr === 'undefined') {
                return false;
            }

            let data = {
                'qr': this.qr
            }

            axios.post(route('admin.api.check.document'), data)
                .then((response) => {
                    let data = response.data

                    if (data.hasFile && !data.error) {
                        this.hasFile = true
                        this.fileUrl = data.fileUrl
                        this.fileName = data.fileName
                    } else {
                        console.error(data)
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        chooseFile(id) {
            document.getElementById(id).click()
        },

        processFile($event) {
            let file = $event.target.files[0]
            let formData = new FormData()

            formData.append('file', file)
            formData.append('qr', this.qr)

            axios.post(
                route('admin.api.handle.document'),
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    let data = response.data

                    if (data.hasFile && !data.error) {
                        this.hasFile = true
                        this.fileUrl = data.fileUrl
                        this.fileName = data.fileName
                    } else {
                        console.error(data.error)
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        removeFile() {
            let data = {
                'qr': this.qr
            }

            axios.post(route('admin.api.delete.document'), data)
                .then((response) => {
                    let data = response.data

                    if (data.deleted && !data.error) {
                        this.hasFile = false
                        this.fileUrl = ''
                        this.fileName = ''
                    } else {
                        console.error(data.error)
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },

    },
}
</script>
